/* Clever Select web component */
customElements.define('selected-option', class extends HTMLElement {});
customElements.define('clever-options', class extends HTMLElement {});

class CleverSelect extends HTMLElement {
  constructor() {
      super();
  }
  connectedCallback() {
      const that = this;
      //Wrap options in custom container
      this._wrapOptions();

      //create value holding input
      this._createValueHolder();

      //Get all options
      this.options = this.querySelectorAll('clever-option')

      //Create selected option display
      this._createSelectedOptionDisplay()

      //Set event listener for toggling the Select
      this.querySelector('selected-option').addEventListener('click',(e) => {
          that.toggleOpenState();
      })
      this.options.forEach(option => {
          //Set initial selected option
          if(option.hasAttribute('selected')){
              that._setSelectedOption(option, false)
          }
          //Add event listeners to all options
          option.addEventListener('click',(e)=>{
              if(!option.hasAttribute('disabled')){
                  e.preventDefault()
                  that._setSelectedOption(option)
                  that.close();
              }
          })
      })

      //Set event listener to close when focus out
      document.body.addEventListener('click',(e) => {
          if(that.hasAttribute('open') && !that.contains(e.target)){
              that.close()
          }
      })
  }
  toggleOpenState(){
      if(this.hasAttribute('open')){
          this.removeAttribute('open')
      }
      else{
          this.setAttribute('open','')
      }
  }
  close(){
      this.removeAttribute('open')
  }

  //this functions should only be used by the element itself
  _setSelectedOption(option, events = true){
      this.value = option.getAttribute('value')
      this.options.forEach(option => {
          option.removeAttribute('selected')
      })
      option.setAttribute('selected', true)
      this.setAttribute('value',this.value)
      this.input.setAttribute('value',this.value)
      this.selectedOption.innerHTML = option.innerHTML;
      if(events){
          this.input.dispatchEvent(new Event('change', {bubbles: true, cancelable: false, composed: true}))
          this.input.dispatchEvent(new Event('input', {bubbles: true, cancelable: false, composed: true}))
      }
  }
  _wrapOptions(){
      let wrappedContent = document.createElement('clever-options');
      let options = this.querySelectorAll('option')
      options.forEach(o => {
          let no = document.createElement('clever-option')
          no.value = o.value;
          no.setAttribute('value', o.value)
          if(o.hasAttribute('selected')){
              no.selected = o.selected;
              no.setAttribute('selected', o.selected)     
          }
          if(o.hasAttribute('disabled')){
              no.disabled = o.disabled;
              no.setAttribute('disabled', o.disabled)     
          }


          no.innerHTML = o.innerHTML;
          wrappedContent.appendChild(no)
      })
      this.innerHTML = wrappedContent.outerHTML;
  }
  _createSelectedOptionDisplay(){
      this.selectedOption = document.createElement('selected-option');
      this.selectedOption.innerHTML = String(this.getAttribute('placeholder'))
      this.appendChild(this.selectedOption)
  }
  _createValueHolder(){
      this.input = document.createElement('input')
      this.input.type = 'text'
      this.input.setAttribute('hidden','')
      this.input.setAttribute('name', this.getAttribute('name'))
      this.removeAttribute('name')
      this.appendChild(this.input)
  }
}
customElements.define('clever-select', CleverSelect);